var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reveal reveal-medium vuw-min-h-300",attrs:{"id":"mainPopup","data-reveal":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }